module.exports = __webpack_public_path__ + "static/media/industry-conect-logo.760c0a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/billing-icons/industry-conect-logo.png
// module id = 1270
// module chunks = 17